import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';

export interface GetOasisCellVars {
    awsAccountId: string;
    collectionId: string;
}

const GET_OASIS_CELL = gql`
    query GetOasisCell(
            $awsAccountId: String
            $collectionId: String
        ){
        getOasisCell(
            awsAccountId: $awsAccountId
            collectionId: $collectionId
        )
    }
`;

export const useGetOasisCellQuery = () => {
    return useLazyQuery<AnyObject, GetOasisCellVars>(GET_OASIS_CELL, {
        errorPolicy: 'all',
    });
};
